/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgQuotationMarks88(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={176}
      height={176}
      fill='none'
      viewBox='0 0 176 176'
      {...props}
    >
      <path
        fill='#F4F6F8'
        fillRule='evenodd'
        d='M59.325 78.968c7.566 3.096 13.499 8 17.798 14.71 4.299 6.709 6.448 14.709 6.448 23.999 0 12.388-3.955 22.538-11.865 30.452C63.796 156.043 53.995 160 42.301 160c-12.38 0-22.526-3.957-30.436-11.871C3.955 140.215 0 130.065 0 117.677c0-6.193.774-12.215 2.321-18.064 1.548-5.85 4.557-14.624 9.028-26.323L38.69 0h41.27L59.325 78.968zm92 0c7.566 3.096 13.499 8 17.798 14.71 4.299 6.709 6.448 14.709 6.448 23.999 0 12.388-3.955 22.538-11.865 30.452-7.91 7.914-17.711 11.871-29.405 11.871-12.381 0-22.526-3.957-30.436-11.871C95.955 140.215 92 130.065 92 117.677c0-6.193.774-12.215 2.321-18.064 1.548-5.85 4.557-14.624 9.028-26.323L130.69 0h41.27l-20.635 78.968z'
      />
    </svg>
  );
}

export default SvgQuotationMarks88;
